import AttendanceView    from '../AttendanceView.vue'
import AttendanceGrid    from '../Pages/AttendanceGrid.vue'
import AttendanceSummary from '../Pages/AttendanceSummary.vue'
import AttendanceUpload  from '../Pages/AttendanceUpload.vue'

const routes = [
  {
    path: '/asistencia',
    component: AttendanceView,
    children: [
      { path: 'control', name: 'attendance-grid',    component: AttendanceGrid    },
      { path: 'resumen', name: 'attendance-summary', component: AttendanceSummary },
      { path: 'carga',   name: 'attendance-upload',  component: AttendanceUpload  },
    ],
  },
]

export default routes
